module.exports = __webpack_public_path__ + "img/hero-myapp-deargod.4e6e8e61.svg";